import { render, staticRenderFns } from "./DiscButton.vue?vue&type=template&id=5fd3b276&scoped=true"
import script from "./DiscButton.vue?vue&type=script&lang=js"
export * from "./DiscButton.vue?vue&type=script&lang=js"
import style0 from "./DiscButton.vue?vue&type=style&index=0&id=5fd3b276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd3b276",
  null
  
)

export default component.exports